export function createMetaObjectFromArray(metaArray) {
    const obj = {};
    for (const item of metaArray) {
        obj[`${item.id}`] = item;
    }
    return obj;
}
